import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createDrawerNavigator } from '@react-navigation/drawer';
import MapScreen from '../screens/map';
import AddBusinessScreen from '../screens/addBusiness';
import EditScreen from '../screens/edit';
import { Platform, useColorScheme } from 'react-native';
import WebMapScreen from '../screens/webMap';
import { DrawerContent } from '../components/drawerContent';

const Stack = createNativeStackNavigator();
const Drawer = createDrawerNavigator();

function DrawerRoutes() {
  return (
    <Drawer.Navigator
      drawerContent={() => <DrawerContent />}
      initialRouteName="Map"
    >
      <Drawer.Screen
        name="Map"
        component={Platform.OS === 'web' ? WebMapScreen : MapScreen}
        options={{ headerShown: false, title: 'Digital Canvas' }}
      />
    </Drawer.Navigator>
  );
}

export default function AppStack() {
  const colorScheme = useColorScheme();

  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: {
          // backgroundColor: navigationTheme.darkTheme.,
        },
        headerTintColor: colorScheme === 'light' ? 'black' : 'white',
        headerShown: false,

        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
      initialRouteName="Root"
    >
      <Stack.Screen name="Root" component={DrawerRoutes} />
      <Stack.Screen
        name="Add_Business"
        component={AddBusinessScreen}
        options={{ headerTitle: '' }}
      />

      <Stack.Screen
        name="Edit"
        component={EditScreen}
        options={{ headerTitle: '' }}
      />
    </Stack.Navigator>
  );
}
